import './BookProfilePage.scss';
import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';


export default function BookProfilePage({ book, onClose, onCheckout }) {

    const [activeTab, setActiveTab] = useState('description');

    if (!book) {
        return null;
    }

    return (
        <div className="book-profile-overlay">

                <button
                    className="exit-button"
                    onClick={onClose}
                >
                    ← Back to Library
                </button>

            <div className="book-profile-card">
                <div>
                    {book.coverImage || book.cover ? (
                        <img
                            className="book-image"
                            alt={book.title}
                            src={book.coverImage || book.cover}
                        />
                    ) : (
                        // NEEDS TO BE CHANGED:
                        // Salesforce/API does not currently provide a confirmed
                        // cover field. Do not use demo cover data.
                        <div className="book-image">
                            No Cover
                        </div>
                    )}
                </div>

                <div className="book-details">
                    <div className="book-title">
                        {book.title}
                    </div>

                    <div className="author-name">
                        By {book.author}
                    </div>

                    <div className="genre-publication-year">
                        {book.genre} - {book.publicationYear}
                    </div>

                    <div className="book-status">
                        {book.isAvailable
                            ?
                            <>
                                <div className="book-status-available">
                                    Available
                                </div>

                             <Tooltip title="Click to checkout this book" placement="top" arrow enterDelay={500} enterNextDelay={500} data-testid="checkout-tooltip">
                                <button
                                    className="checkout-btn"
                                    onClick={onCheckout}
                                >
                                    Check Out
                                </button>
                            </Tooltip>
                            </>
                            :
                            <>
                                <div className="book-status-checked-out">
                                    Checked Out
                                </div>

                                <div className="book-checked-out-by">
                                    Checked Out By:
                                </div>

                                <div className="book-checked-out-by-user">
                                    {book.checkedOutBy || 'Unavailable'}
                                </div>

                                <div className="book-checked-out">
                                    Checked Out:
                                </div>

                                <div className="book-check-out-date">
                                    {book.checkOutDate || 'Unavailable'}
                                </div>

                                {book.dueDate && (
                                    <>
                                        <div className="book-checked-out">
                                            Due:
                                        </div>

                                        <div className="book-check-out-date">
                                            {book.dueDate}
                                        </div>
                                    </>
                                )}
                            </>
                        }
                    </div>
                </div>
            </div>

            <div className="description-caption">
                <Tooltip title="Click to see description" placement="top" arrow enterDelay={500} enterNextDelay={500} data-testid="description-tooltip">
                    <span
                        className={
                            activeTab === 'description'
                                ? 'tab active'
                                : 'tab'
                        }
                        onClick={() => setActiveTab('description')}
                    >
                        Description
                    </span>
                </Tooltip>

                <span className="tab-active-divider">
                    {' '}|{' '}
                </span>

                <Tooltip title="Click to see remarks" placement="top" arrow enterDelay={500} enterNextDelay={500} data-testid="remarks-tooltip">
                    <span
                        className={
                            activeTab === 'remarks'
                                ? 'tab active'
                                : 'tab'
                        }
                        onClick={() => setActiveTab('remarks')}
                    >
                        Remarks
                    </span>
            </Tooltip>
            </div>

            <div className="full-description">
                {activeTab === 'description'
                    ? (book.description || "No description available.")
                    : (book.remarks || "No remarks available.")}
            </div>
        </div>
    );
}